<template>
	<LayoutForm>
		<h1 slot="header">Delete Document Category</h1>
		<form class="form" ref="form" @submit.prevent="submit" novalidate>
			<ValidationAlert :error-list="errors.collect('server')" />
			<ValidationAlert v-if="serverErrors" :error-list="serverErrors" />
			<fieldset class="form__group">
				<FormControlInsightCategory
                    v-model="formData.category"
                    label="Select a category"
                    ref="cats"
                    name="category"
                />
                <div class="checkbox">
                    <input id="delete_children" type="checkbox" v-model="formData.delete_children" />
                    <label for="delete_children">Delete child categories?</label>
                </div>
                <div class="form__group form__group--submit">
                    <button class="btn btn--primary" v-wait:disabled='"submit"'>
                        <Spinner :height="13" :width="13" v-if="$wait.is('submit')" />
                        <span v-else>Delete</span>
                    </button>
                </div>
			</fieldset>
		</form>
	</LayoutForm>
</template>

<script>
	import API from '@api';
	import LayoutForm from '../Layout/LayoutForm';
	import FormControlInsightCategory from '../Form/Control/FormControlInsightCategory';
	import ValidationAlert from '../ValidationAlert';
	import Form from '../Form/Form';
    import Spinner from '@components/Spinner';
    import FileUpload from '@components/Form/FileUpload';

	export default {
		name: 'InsightCategoryDeleteForm',
		mixins: [Form],
		components: {
            FileUpload,
            Spinner,
			ValidationAlert,
			FormControlInsightCategory,
			LayoutForm,
		},
		data() {
			return {
                serverErrors: [],
				formData: {
					category: 0,
                    delete_children: false
				}
			}
		},
		methods: {
			sanitizeResource(data) {
				return data;
			},
			async submit() {
                if(this.$wait.is('submit'))
                    return;

                const result = await this.$validator.validateAll();

                if(!result) {
                    this.$wait.end('submit');
                    return;
                }

                try {
                    this.$wait.start('submit');

                    await API.deleteInsightCategory(
                        this.formData.category,
                        { delete_children: this.formData.delete_children }
                    );

                    this.$router.push({ name: 'insights' });
                } catch(error) {
                    this.serverErrors = [error.response.data.message];
                } finally {
                    this.$wait.end('submit');
                }
			}
		},
	}
</script>
<style scoped lang="scss">
@import '~@/theme/_variables.scss';

.checkbox {
    input[type="checkbox"] {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0,0,0,0);
        border: 0;

        + label {
            position: relative;
            padding-left: 2rem;
            color: #657787;

            &:before {
                content: "";
                width: 1.4rem;
                height: 1.4rem;
                border-radius: .4rem;
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                background-color: #b5bcc3;
            }
        }

        &:checked + label:before {
            background-color: $accent;
            background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 512 512"><path fill="%23fff" d="m173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69L432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"/></svg>');
            background-size: 1rem;
            background-position: center;
            background-repeat: no-repeat;
        }
    }
}
</style>
